/* eslint-disable prefer-destructuring */
/**

Coded by www.techhighway.ca

*/

// @mui material components
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

export default styled(Switch)(({ theme, ownerState }) => {
  const { palette, functions } = theme;
  const { checked, color, defaultChecked, disabled, size } = ownerState;

  return {};
});
